<template>
    <v-select
        v-bind="$attrs"
        v-on="$listeners"
        :calculate-position="withPopper"
        append-to-body
    >
        <!-- pass through scoped slots -->
        <template v-for="(_, scopedSlotName) in $scopedSlots" v-slot:[scopedSlotName]="slotData">
            <slot :name="scopedSlotName" v-bind="slotData" />
        </template>

        <!-- pass through normal slots -->
        <template v-for="(_, slotName) in $slots" v-slot:[slotName]>
            <slot :name="slotName" />
        </template>
    </v-select>
</template>
<script>
import vSelect from 'vue-select';
import { createPopper } from '@popperjs/core';

export default {
    components: {
        vSelect,
    },
    props: {
        placement: {
            type: String,
            default: 'bottom',
        },
    },
    methods: {
        withPopper(dropdownList, component, { width }) {
            /**
             * We need to explicitly define the dropdown width since
             * it is usually inherited from the parent with CSS.
             */
            dropdownList.style.width = `calc(32px + ${width})`;
            dropdownList.style.zIndex = 99999999999;

            /**
             * Here we position the dropdownList relative to the $refs.toggle Element.
             *
             * The 'offset' modifier aligns the dropdown so that the $refs.toggle and
             * the dropdownList overlap by 1 pixel.
             *
             * The 'toggleClass' modifier adds a 'drop-up' class to the Vue Select
             * wrapper so that we can set some styles for when the dropdown is placed
             * above.
             */
            const popper = createPopper(component.$refs.toggle, dropdownList, {
                placement: this.placement,
                modifiers: [
                    {
                        name: 'preventOverflow',
                        enabled: true,
                        phase: 'write',
                        options: {
                            mainAxis: false,
                            boundary: 'viewport',
                            rootBoundary: 'viewport',
                        },
                    },
                    {
                        name: 'offset',
                        options: {
                            offset: [0, -1],
                        },
                    },
                    {
                        name: 'toggleClass',
                        enabled: true,
                        phase: 'write',
                        fn({ state }) {
                            component.$el.classList.toggle(
                                'drop-up',
                                state.placement === 'top',
                            );
                        },
                    },
                ],
            });

            /**
             * To prevent memory leaks Popper needs to be destroyed.
             * If you return function, it will be called just before dropdown is removed from DOM.
             */
            return () => popper.destroy();
        },
    },
};
</script>
